/* eslint-disable camelcase */

import createCardReadinessObserver from './cardHelper';

if (window.HP.params.isFrontFlex) {
  const timestampClass = 'js-timestamp';
  const newClass = 'js-new'; // new is not a type of badge and only shows on badgeless cards
  const trendingClass = 'js-trending';
  const zoneTrendingClass = 'js-has-trending-card';
  const oneHour = 60 * 60 * 1000;
  const { trendingEntryIDs } = window.HP.params;
  const counter = {
    trending: 0,
  };

  // Track which cards have been processed to avoid duplicate processing
  const processedCards = new Set();

  const updateItemTypeForCardBadge = (card, badgeType) => {
    const cardParent = card.closest('.card[data-vars-item-type]');
    if (cardParent) {
      const currentValue = cardParent.getAttribute('data-vars-item-type');
      const updatedValue = currentValue === 'card' ? `card_${currentValue}=${badgeType}` : `${currentValue}&badge=${badgeType}`;
      cardParent.setAttribute('data-vars-item-type', updatedValue);
    }
  };

  const processBadgeForCard = (card) => {
    const { liveblogEndTime, timestamp, varsItemName: entryId } = card.dataset;

    // Skip if already processed
    if (processedCards.has(entryId)) {
      return;
    }
    processedCards.add(entryId);

    let badge;
    try {
      badge = JSON.parse(card.dataset.badge);
    } catch (e) {
      badge = {};
    }
    const {
      start_time, end_time, value, bg_color, label, text_color,
    } = badge;
    const hasBadgeData = !!value;
    const isCustomBadge = !!label;
    const zoneParent = card.closest('.zone');

    const parentDiv = card.querySelector('.card__text__top');
    if (!parentDiv) {
      return; // Card might not be fully rendered yet
    }

    const now = Date.now();
    let start;
    let end;
    if (start_time) {
      start = new Date(start_time).getTime();
    }
    if (end_time) {
      end = new Date(end_time).getTime();
    }

    const isLive = now >= start && (!end || now < end);
    const showBadge = hasBadgeData && isLive;
    let hasBadge = false;

    // manual badge check
    if (showBadge) {
      hasBadge = true;
      const badgeDiv = document.createElement('div');
      if (isCustomBadge) {
        badgeDiv.className = 'card__badge card__badge--custom';
        badgeDiv.style.backgroundColor = bg_color;
        badgeDiv.style.color = text_color;
        badgeDiv.innerHTML = label;
      } else {
        badgeDiv.className = `card__badge card__badge--${value}`;
        let text = value.replace('-', ' ').toUpperCase();
        if (value === 'last-chance') {
          text = `${text}!`;
        }
        badgeDiv.innerHTML = text;
      }
      parentDiv.classList.add('card__text__top--has-badge');
      updateItemTypeForCardBadge(card, value);
      parentDiv.appendChild(badgeDiv);
    }

    // liveblog check
    if (liveblogEndTime > now && !hasBadge) {
      hasBadge = true;
      const liveblogDiv = document.createElement('div');
      liveblogDiv.className = 'card__badge card__badge--liveblog';
      liveblogDiv.innerHTML = 'LIVE';
      parentDiv.classList.add('card__text__top--has-badge');
      updateItemTypeForCardBadge(card, 'liveblog');
      parentDiv.appendChild(liveblogDiv);
    }

    // timestamp check -- must happen after other badge checks
    const msAgo = now - timestamp;
    if (msAgo < oneHour) {
      // if no badge is present add NEW stamp
      if (!hasBadge) {
        card.classList.add(newClass);
        hasBadge = true;
        const newDiv = document.createElement('div');
        newDiv.className = 'card__new';
        newDiv.innerHTML = 'NEW';
        updateItemTypeForCardBadge(card, 'new');
        parentDiv.appendChild(newDiv);
      }

      // add timestamp to any "new" cards
      const minutesAgo = Math.floor(msAgo / 60000);
      card.classList.add(timestampClass);
      const timestampDiv = document.createElement('div');
      timestampDiv.className = 'card__timestamp';
      timestampDiv.innerHTML = minutesAgo < 1 ? 'a few sec ago' : `${minutesAgo} min ago`;
      parentDiv.classList.add('card__text__top--has-badge');
      parentDiv.appendChild(timestampDiv);
    }

    // trending check -- lowest priority
    if (
      !hasBadge
      && counter.trending < 2
      && !zoneParent.classList.contains(zoneTrendingClass)
      && trendingEntryIDs.includes(entryId)
    ) {
      hasBadge = true;
      card.classList.add(trendingClass);
      zoneParent.classList.add(zoneTrendingClass);
      counter.trending += 1;
      const trendingDiv = document.createElement('div');
      trendingDiv.className = 'card__badge card__badge--trending';
      trendingDiv.innerHTML = 'TRENDING';
      parentDiv.classList.add('card__text__top--has-badge');
      updateItemTypeForCardBadge(card, 'trending');
      parentDiv.appendChild(trendingDiv);
    }
  };

  const processAllBadges = () => {
    const allCards = document.querySelectorAll('.front-page-content .js-can-badge, .front-page-top .js-can-badge');
    allCards.forEach((card) => {
      processBadgeForCard(card);
    });
    window.doImpressions('badgeCards');
  };

  const flexProCardsWithBadges = document.querySelectorAll('.js-card-flex-pro.js-can-badge');

  if (flexProCardsWithBadges.length === 0) {
    // No FlexPro cards with badges, process all badges immediately
    console.log('[badges] No FlexPro cards with badges, processing immediately');
    processAllBadges();
  } else {
    // Use observer to wait for FlexPro cards to be ready
    // Target specific containers for better performance
    createCardReadinessObserver(
      '.js-card-flex-pro.js-can-badge',
      processAllBadges,
      'badges',
      ['.js-can-have-flex-pro'], // Class of the container that can have FlexPro cards (those that hydrate hence the observer), we can add more containers when we expand to bpages and other recircs
    );
  }
}
